import * as types from '../actions/types'

const initialState = {}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.STORE_CENTRIFUGE_INSTANCE:
      return payload
    case types.CENTRIFUGE_CHANNEL_SUBSCRIBED:
      return {
        ...state,
        [payload]: true,
      }
    case types.CENTRIFUGE_MULTIPLE_CHANNEL_SUBSCRIBED:
      return {
        ...state,
        ...payload,
      }
    default:
      return state
  }
}
